export default __webpack_public_path__ + "static/media/public-blue.94113fbc.png";